import React from 'react'

export default function ConfirmModal({ title, text, unsubscribeAllHandler }) {
  return (
    <>
      {/* TODO: Refactor modal backdrop click handling to semantic keyboard-accessible controls. (CTINEXT-4684) */}
      {/* eslint-disable-next-line */}
      <div className="Modal" onClick={(e) => unsubscribeAllHandler(e, 2)}>
        {/* TODO: Refactor modal shell interactions to semantic controls with keyboard support
            to avoid relying on click handlers on non-interactive containers. */}
        {/* eslint-disable-next-line */}
        <section className="Modal-window" onClick={(e) => e.stopPropagation()}>
          <div className="Modal-content">
            <h2 className="u-marginBottom4gu">{title}</h2>
            <p>{text}</p>
            <button
              className="Modal-icon u-textPrimary u-posAbsolute u-posAbsoluteTop u-posAbsoluteRight u-marginRight3gu u-marginTop2gu"
              onClick={(e) => unsubscribeAllHandler(e, 2)}
              aria-label="Close"
            ></button>
          </div>
          <footer className="Modal-footer Modal-footer u-marginHoriz6gu u-paddingHoriz0 u-paddingBottom5gu">
            <div className="ButtonRow">
              <button
                className="Button Button--secondary u-paddingHoriz4gu u-paddingVert2gu u-inlineBlock u-textNoTransform"
                onClick={(e) => unsubscribeAllHandler(e, 1)}
                data-analytics="sc-unsubscribe-all-confirm"
              >
                Yes
              </button>
              <button
                className="Button Button--tertiary u-inlineBlock u-marginLeft1gu u-textNoTransform"
                onClick={(e) => unsubscribeAllHandler(e, 2)}
              >
                Cancel
              </button>
            </div>
          </footer>
        </section>
      </div>
    </>
  )
}
